import LearningpathList from './LearningpathList.vue';
import Learningpath from './Learningpath.vue';

export default {
  LearningpathList,
  Learningpath,
};
